import { call, put } from 'redux-saga/effects';
import { fetchSubscribersSuccess, fetchSubscribersFailure } from '../slice';
import { GET, getHeaders } from 'src/services/ApiService';

export function* getSubscribers() {
    const result = yield call(GET, '/providers/service/subscriptions', getHeaders('3.0'));
    if (result.isSuccess) {
        yield put(
            fetchSubscribersSuccess({
                rows: result.response,
            })
        );
    } else {
        yield put(fetchSubscribersFailure(result));
    }
}
